import { useEffect, useRef } from 'react';
import { staticPath } from '../../../../../schema/Environment';

// Чистая логика медиа-виджета (превью/placeholder/типы/GC). Без верстки.

const IMAGE_EXTS = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'bmp'];
const AUDIO_EXTS = ['mp3', 'ogg', 'wav', 'm4a', 'aac', 'flac', 'opus'];
const VIDEO_EXTS = ['mp4', 'webm', 'mov', 'avi', 'mkv', 'm4v'];

export function resolvePreviewUrl(item) {
    if (!item) return null;
    if (item.__previewUrl) return item.__previewUrl;
    if (item.mediaFileUrl) return item.mediaFileUrl;
    if (item.url) return item.url;
    if (item.filePath) return item.filePath.startsWith('http') ? item.filePath : staticPath + item.filePath;
    return null;
}

function inferTypeFromMime(mime) {
    if (!mime) return null;
    if (mime.startsWith('image/')) return 'IMAGE';
    if (mime.startsWith('audio/')) return 'AUDIO';
    if (mime.startsWith('video/')) return 'VIDEO';
    return null;
}

function inferTypeFromExtension(urlOrName) {
    if (!urlOrName) return null;
    const cleaned = urlOrName.split('?')[0].split('#')[0];
    const dot = cleaned.lastIndexOf('.');
    if (dot < 0) return null;
    const ext = cleaned.slice(dot + 1).toLowerCase();
    if (IMAGE_EXTS.includes(ext)) return 'IMAGE';
    if (AUDIO_EXTS.includes(ext)) return 'AUDIO';
    if (VIDEO_EXTS.includes(ext)) return 'VIDEO';
    return null;
}

export function inferMediaType(item) {
    if (!item) return null;
    if (item.__type) return item.__type;
    if (item.fileExtensionType) return item.fileExtensionType;
    return inferTypeFromExtension(item.mediaFileUrl)
        || inferTypeFromExtension(item.url)
        || inferTypeFromExtension(item.filePath)
        || inferTypeFromExtension(item.__fileName);
}

export function makePendingPlaceholder(file) {
    return {
        id: null,
        __pending: true,
        __previewUrl: URL.createObjectURL(file),
        __fileName: file.name,
        __type: inferTypeFromMime(file.type) || inferTypeFromExtension(file.name)
    };
}

export function itemMatchesType(item, mediaType) {
    if (!item) return false;
    const inferred = inferMediaType(item);
    if (inferred) return inferred === mediaType;
    return mediaType === 'IMAGE';
}

export function pendingIndexOf(value, target) {
    let count = 0;
    for (let i = 0; i < value.length; i += 1) {
        if (value[i] === target) return count;
        if (value[i] && value[i].__pending) count += 1;
    }
    return -1;
}

// Освобождает object-URL'ы, когда элемент уходит из value или компонент размонтируется.
export function useObjectUrlGc(items) {
    const trackedRef = useRef(new Set());
    useEffect(() => {
        const referenced = new Set((items || []).map(it => it && it.__previewUrl).filter(Boolean));
        trackedRef.current.forEach(url => {
            if (!referenced.has(url)) { URL.revokeObjectURL(url); trackedRef.current.delete(url); }
        });
        referenced.forEach(url => trackedRef.current.add(url));
    }, [items]);
    useEffect(() => () => {
        trackedRef.current.forEach(url => URL.revokeObjectURL(url));
        trackedRef.current.clear();
    }, []);
}
